import LiveBadge from "../badges/livebadge";
import Badge from "../badges/badge";
import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import api from "../../utils/axiosConfig";
import dayjs from "dayjs";

const MatchPredictions = () => {
  const [dailyTops, setDailyTops] = useState([]);
  const [resultTops, setResultTops] = useState([]);
  const [ggngTops, setGGNGTops] = useState([]);
  const [overUnderTops, setOverUnderTops] = useState([]);

  useEffect(() => {
    // fetch daily top picks
    api.get("/fixtures/dailyTops").then((res) => {
      // console.log(res.data);
      setDailyTops(res.data.topFixtures);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  useEffect(() => {
    api.get("/fixtures/topPicks").then((res) => {
      // console.log(res.data);
      setResultTops(res.data.topResult);
      setGGNGTops(res.data.topGGNG);
      setOverUnderTops(res.data.topOverUnder);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  return (
    <div className="bg-white rounded-2xl p-6 shadow-md w-full max-w-5xl mx-auto text-xs">
      <div className="mb-6">
        <div className="flex items-center bg-red-400 text-secondary font-semibold px-4 py-2 rounded-full w-fit">
          <span className="text-xs mr-2">&#x25CF;</span>
          <span className="text-xs">Daily Top Picks</span>
        </div>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
          {dailyTops.map((topPick, idx) => {
            const time = topPick.date.split("T")[1];
            const [hour, mins] = time.split(":");
            const matchTime = dayjs(time);
            const matchEndTime = matchTime.add(2, "hours");
            const currentTime = dayjs();
            const isLive = matchTime <= currentTime && matchEndTime >= currentTime;

            const highestProbabilty = Math.max(topPick.resultProba, topPick.ggngProba, topPick.overUnderProba);

            return (
              <div key={idx} className="border border-gray-200 rounded-lg p-4 flex flex-col space-y-4">
                <div className="flex flex-wrap justify-between items-center">
                  <div className="flex items-center space-x-2">
                    <div className="text-gray-400 text-sm flex flex-col leading-tight relative bottom-2">
                      <span>{hour}</span>
                      <span>{mins}</span>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex items-center space-x-2">
                        <img src={topPick.homeTeamEmblem} alt="Home Team" className="w-5 h-5" />
                        <span className="text-black font-medium">{topPick.homeTeam}</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <img src={topPick.awayTeamEmblem} alt="Away Team" className="w-5 h-5" />
                        <span className="text-black font-medium">{topPick.awayTeam}</span>
                      </div>
                      <div className="p-1 mt-2">
                        {isLive && <LiveBadge />}
                      </div>
                    </div>
                  </div>
                  <div className="text-gray-400 text-sm flex flex-col relative bottom-2">Prediction:
                    {topPick.league === "NBA" || topPick.league === "NCAA" ? (
                      <span className="font-bold text-secondary">
                        {highestProbabilty === topPick.resultProba
                          ? (topPick.resultPrediction === "home" ? "Home Win" : "Away Win")
                          : (topPick.overUnderPrediction === "Over"
                              ? `Over ${topPick.league === "NBA" ? "200.5" : "150.5"}`
                              : `Under ${topPick.league === "NBA" ? "200.5" : "150.5"}`)}
                      </span>
                    ) : (
                      <span className="font-bold text-secondary">
                        {highestProbabilty === topPick.resultProba ? (topPick.resultPrediction === "1" ? "Home Win" : topPick.resultPrediction === "X" ? "Draw" : topPick.resultPrediction === "2" ? "Away Win" : topPick.resultPrediction === "1X" ? "Home Win or Draw" : topPick.resultPrediction === "X2" ? "Draw or Away Win" : "Home Win or Away Win") : highestProbabilty === topPick.ggngProba ? (topPick.ggngPrediction === "1" ? "GG" : "NG") : (topPick.overUnderPrediction === "Over" ? "Over 2.5" : "Under 2.5")}
                      </span>
                    )}
                  </div>
                  {topPick.played && (
                    <>
                      {topPick.league === "NBA" || topPick.league === "NCAA" ? (
                        <span className="text-gray-400 text-sm flex flex-col">Result:{" "}
                          <div className="relative right-3">
                            <Badge
                              status={`${highestProbabilty === topPick.resultProba ? (topPick.wonResultPrediction ? "won" : "lost") : (topPick.wonOverUnderPrediction ? "won" : "lost")}`}
                            />
                          </div>
                        </span>
                      ) : (
                        <span className="text-gray-400 text-sm flex flex-col">Result:{" "}
                          <div className="relative right-3">
                            <Badge
                              status={`${highestProbabilty === topPick.resultProba ? (topPick.wonResultPrediction ? "won" : "lost") : highestProbabilty === topPick.ggngProba ? (topPick.wonGGNGPrediction ? "won" : "lost") : (topPick.wonOverUnderPrediction ? "won" : "lost")}`}
                            />
                          </div>
                        </span>
                      )}
                    </>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
  
        <div className="mb-6">
          <div className="flex items-center bg-green-400 text-secondary font-semibold px-4 py-2 rounded-full w-fit">
            <span className="text-xs mr-2">&#x25CF;</span>
            <span className="text-xs">Results Prediction</span>
          </div>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            {resultTops.map((topPick, idx) => {
              const time = topPick.date.split("T")[1];
              const [hour, mins] = time.split(":");
              const matchTime = dayjs(time);
              const matchEndTime = matchTime.add(2, "hours");
              const currentTime = dayjs();
              const isLive = matchTime <= currentTime && matchEndTime >= currentTime;
  
              return (
                <div key={idx} className="border border-gray-200 rounded-lg p-4 flex flex-col space-y-4">
                  <div className="flex flex-wrap justify-between items-center">
                    <div className="flex items-center space-x-2">
                      <div className="text-gray-400 text-sm flex flex-col leading-tight relative bottom-2">
                        <span>{hour}</span>
                        <span>{mins}</span>
                      </div>
                      <div className="flex flex-col">
                        <div className="flex items-center space-x-2">
                          <img src={topPick.homeTeamEmblem} alt="Home Team" className="w-5 h-5" />
                          <span className="text-black font-medium">{topPick.homeTeam}</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <img src={topPick.awayTeamEmblem} alt="Away Team" className="w-5 h-5" />
                          <span className="text-black font-medium">{topPick.awayTeam}</span>
                        </div>
                        <div className="p-1 mt-2">
                          {isLive && <LiveBadge />}
                        </div>
                      </div>
                    </div>
                    <div className="text-gray-400 text-sm flex flex-col relative bottom-2">Prediction:{" "}
                      {topPick.league === "NBA" || topPick.league === "NCAA"? (
                        <span className="font-bold text-secondary">
                          {topPick.resultPrediction === "home" ? "Home Win" : "Away Win"}
                        </span>
                      ) : (
                        <span className="font-bold text-secondary">
                          {topPick.resultPrediction === "1" ? "Home Win" : topPick.resultPrediction === "X" ? "Draw" : topPick.resultPrediction === "2" ? "Away Win" : topPick.resultPrediction === "1X" ? "Home Win or Draw" : topPick.resultPrediction === "X2" ? "Draw or Away Win" : "Home Win or Away Win"}
                        </span>
                      )}
                    </div>
                    {topPick.played && (
                      <>
                      <span className="text-gray-400 text-sm flex flex-col">Result:{" "}
                        <div
                          className="relative right-3"
                        >
                          <Badge status={topPick.wonResultPrediction ? "won" : "lost"} />
                        </div>
                      </span>
                      </>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
  
        <div className="mb-6">
          <div className="flex items-center bg-yellow-400 text-secondary font-semibold px-4 py-2 rounded-full w-fit">
            <span className="text-xs mr-2">&#x25CF;</span>
            <span className="text-xs">
              GG/NG Predictions
            </span>
          </div>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            {ggngTops.map((topPick, idx) => {
              const time = topPick.date.split("T")[1];
              const [hour, mins] = time.split(":");
              const matchTime = dayjs(time);
              const matchEndTime = matchTime.add(2, "hours");
              const currentTime = dayjs();
              const isLive = matchTime <= currentTime && matchEndTime >= currentTime;
  
              return (
                <div key={idx} className="border border-gray-200 rounded-lg p-4 flex flex-col space-y-4">
                  <div className="flex flex-wrap justify-between items-center">
                    <div className="flex items-center space-x-2">
                      <div className="text-gray-400 text-sm flex flex-col leading-tight relative bottom-2">
                        <span>{hour}</span>
                        <span>{mins}</span>
                      </div>
                      <div className="flex flex-col">
                        <div className="flex items-center space-x-2">
                          <img src={topPick.homeTeamEmblem} alt="Home Team" className="w-5 h-5" />
                          <span className="text-black font-medium">{topPick.homeTeam}</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <img src={topPick.awayTeamEmblem} alt="Away Team" className="w-5 h-5" />
                          <span className="text-black font-medium">{topPick.awayTeam}</span>
                        </div>
                        <div className="p-1 mt-2">
                          {isLive && <LiveBadge />}
                        </div>
                      </div>
                    </div>
                    <div className="text-gray-400 text-sm flex flex-col relative bottom-2">Prediction:{" "}
                      <span className="font-bold text-secondary">
                        {topPick.ggngPrediction === "1" ? "GG" : "NG"}
                      </span>
                    </div>
                    {topPick.played && (
                      <>
                      <span className="text-gray-400 text-sm flex flex-col">Result:{" "}
                        <div
                          className="relative right-3"
                        >
                          <Badge status={topPick.wonGGNGPrediction ? "won" : "lost"} />
                        </div>
                      </span>
                      </>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
  
        <div className="mb-6">
          <div className="flex items-center bg-blue-400 text-secondary font-semibold px-4 py-2 rounded-full w-fit">
            <span className="text-xs mr-2">&#x25CF;</span>
            <span className="text-xs">
              Over/Under Predictions
            </span>
          </div>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            {overUnderTops.map((topPick, idx) => {
              const time = topPick.date.split("T")[1];
              const [hour, mins] = time.split(":");
              const matchTime = dayjs(time);
              const matchEndTime = matchTime.add(2, "hours");
              const currentTime = dayjs();
              const isLive = matchTime <= currentTime && matchEndTime >= currentTime;
  
              return (
                <div key={idx} className="border border-gray-200 rounded-lg p-4 flex flex-col space-y-4">
                  <div className="flex flex-wrap justify-between items-center">
                    <div className="flex items-center space-x-2">
                      <div className="text-gray-400 text-sm flex flex-col leading-tight relative bottom-2">
                        <span>{hour}</span>
                        <span>{mins}</span>
                      </div>
                      <div className="flex flex-col">
                        <div className="flex items-center space-x-2">
                          <img src={topPick.homeTeamEmblem} alt="Home Team" className="w-5 h-5" />
                          <span className="text-black font-medium">{topPick.homeTeam}</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <img src={topPick.awayTeamEmblem} alt="Away Team" className="w-5 h-5" />
                          <span className="text-black font-medium">{topPick.awayTeam}</span>
                        </div>
                        <div className="p-1 mt-2">
                          {isLive && <LiveBadge />}
                        </div>
                      </div>
                    </div>
                    <div className="text-gray-400 text-sm flex flex-col relative bottom-2">Prediction:{" "}
                      <span className="font-bold text-secondary">
                        {topPick.overUnderPrediction === "Over" ? "Over 2.5" : "Under 2.5"}
                      </span>
                    </div>
                    {topPick.played && (
                      <>
                      <span className="text-gray-400 text-sm flex flex-col">Result:{" "}
                        <div
                          className="relative right-3"
                        >
                          <Badge status={topPick.wonOverUnderPrediction ? "won" : "lost"} />
                        </div>
                      </span>
                      </>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
    </div>
  );
};
MatchPredictions.propTypes = {
  setModalOpen: PropTypes.func,
};

export default MatchPredictions;
